import React from "react";
import CommonRow from "../common-row";
const SixteenStories1WidgetWithPollAndLoadMore = props => {
  return <CommonRow {...props} />;
};

export default SixteenStories1WidgetWithPollAndLoadMore;
